<div class="title">{{ consentInfo.title | translate }}</div>
<div class="consent">
    {{ consentInfo.message | translate }}
</div>
<div class="actions">
    <warema-button
        id="back"
        size="small"
        type="secondary"
        [text]="'CANCEL' | translate"
        (click)="goBack()"
        (keydown.enter)="goBack()"
        (keydown.space)="goBack()"
    />
    <warema-button
        data-cy="accept-consent-btn"
        id="accept-consent-btn"
        size="small"
        [text]="'ACCEPT_CONSENT' | translate"
        (click)="acceptConsent()"
        (keydown.enter)="acceptConsent()"
        (keydown.space)="acceptConsent()"
    />
</div>
